import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeadersInterceptor } from './header.Interceptor';
import { NoopInterceptor } from './noop.interceptor';
import { EnsureHttpsInterceptor } from './ensure-https.interceptor';
import { TrimNameInterceptor } from './trim-name.interceptor';
import { AuthInterceptor } from './auth.interceptor';
import { LoggingInterceptor } from './loggin.interceptor';
import { UploadInterceptor } from './upload.interceptor';
import { CachingInterceptor } from './caching.interceptor';

export const ProvidersInterceptors = [
	{ provide: HTTP_INTERCEPTORS, useClass: NoopInterceptor, multi: true },

	{ provide: HTTP_INTERCEPTORS, useClass: EnsureHttpsInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: TrimNameInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: UploadInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true }

];
